<template>
  <div class="togocup-card">
    <div class="header d-flex flex-column position-relative">
      <div class="card-menu-btn">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-if="GET_currentUserProfile && (GET_currentUserProfile.level === 'superadmin' || GET_currentUserProfile.entityId === data.createdBy)"
              icon small v-bind="attrs" v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$emit('edit', data)">
              <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('delete', data)">
              <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <h4 class="title text-md-title font-weight-bold">{{ data.name }}</h4>
      <span>Address: {{ data.streetaddress || "N/A" }}</span>
      <v-btn
        :href="'https://www.google.com/maps/search/?api=1&query=' + data.streetaddress"
        class="font-weight-bold primary white--text"
        depressed
      >
        <v-icon class="white--text">icons8-place-marker</v-icon>
        {{ $t("openinmaps") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ToGoCupCard",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      GET_showDrawer: "GET_showDrawer",
      GET_showFilterDrawer: "GET_showFilterDrawer",
      GET_currentUserProfile: "GET_currentUserProfile",
      GET_authenticated: "GET_authenticated",
    }),
  },
};
</script>

<style lang="scss" scoped>
.togocup-card {
  min-height: 80px;
  overflow: hidden;
  a {
    text-decoration: none;
  }
  cursor: pointer;

  .header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    position: relative;
  }

  .header,
  .body {
    padding: 0.5rem;
  }

  .body ul {
    list-style: none;
    padding-left: 0;
  }

  .card-menu-btn {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    z-index: 2;
  }
}
</style>
